// Create a condition that targets viewports at least 768px wide

const mediaQuery = window.matchMedia("(min-width: 768px)");
let totalTime;
function handleTabletChange(e) {
  const elem = document.querySelector(".responsive-video");

  // Check if the media query is true
  if (e.matches) {
    // Then log the following message to the console

    elem.src = elem.dataset.desk;
    elem.dataset.size = "desktop";
    // elem.poster = elem.dataset.posterdesk;
    elem.play;
    totalTime = elem.duration;
  } else {
    elem.src = elem.dataset.mobile;
    // elem.poster = elem.dataset.postermobile;
    elem.dataset.size = "mobile";
    totalTime = elem.duration;
  }

  elem.addEventListener("timeupdate", videoEnded, false);
}

// Register event listener
mediaQuery.addListener(handleTabletChange);

// Initial check
handleTabletChange(mediaQuery);

function videoEnded(e) {
  const elem = document.querySelector(".responsive-video");
  const totalTime = elem.duration;
  if (totalTime == e.target.currentTime) {
    elem.pause();
    // elem.currentTime = 0;
    // elem.play();
  }
}
